var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-2"},[_c('h3',[_vm._v("Mock time")]),_c('div',[_vm._v("Current time: "+_vm._s(_vm.formattedTime))]),_c('div',[_c('v-layout',[_c('v-select',{attrs:{"items":[
          { text: '5 minutes', value: '5m' },
          { text: '1 hour', value: '1h' },
          { text: '1 day', value: '1d' },
          { text: this.nextEvent, value: 'next' },
        ]},model:{value:(_vm.selectedStep),callback:function ($$v) {_vm.selectedStep=$$v},expression:"selectedStep"}}),_c('v-btn',{staticClass:"mt-3",attrs:{"flat":"","small":""},on:{"click":function($event){return _vm.step(_vm.selectedStep)}}},[_c('v-icon',[_vm._v("forward")])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }